import { Controller } from "@hotwired/stimulus"

// Keyboard support for the inline offer line-item forms: Escape cancels back to
// the display row (Enter submits natively). Quick-add forms remember their "new
// item" href on submit so the tree controller can reopen the same form after the
// full-tree re-render — enabling continuous keyboard entry. Forked from
// boq_row_edit_controller.js.
export default class extends Controller {
  static targets = ["cancel"]
  static values = { reopenHref: String }

  cancel(event) {
    event.preventDefault()
    if (this.hasCancelTarget) this.cancelTarget.click()
  }

  rememberReopen() {
    if (!this.reopenHrefValue) return
    window.__billingOfferReopen = { href: this.reopenHrefValue, at: Date.now() }
  }
}
